const breadCrumb = "Lotação de Servidores - Manutenção de Servidores";

const routes = [
  {
    path: "/cadastro-de-servidor",
    name: "cadastro-de-servidor",
    meta: {
      allowedPermissions: ["area_curso_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeServidor/CadastroDeServidorHome.vue"
      ),
  },
  {
    path: "/cadastro-de-servidor/novo",
    name: "cadastro-de-servidor-novo",
    meta: {
      allowedPermissions: ["area_curso_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeServidor/CadastroDeServidorCad.vue"
      ),
  },
  {
    path: "/cadastro-de-servidor/editar/:id",
    name: "cadastro-de-servidor-editar",
    meta: {
      allowedPermissions: ["area_curso_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeServidor/CadastroDeServidorEdit.vue"
      ),
  },
];

export default routes;
